module.exports = __webpack_public_path__ + "744abff1d671b91e8674af4ca9b2c958.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/url-loader??ref--8-1!./node_modules/image-webpack-loader??ref--8-2!./node_modules/srcset-loader/lib/resize-loader.js?size=1800!./src/components/cover/teaser-dark.png?size=1800w
// module id = 41
// module chunks = 1